export function RouteLoadingFallback() {
  return (
    <div className="grid min-h-screen place-items-center bg-canvas px-5">
      <p className="rounded-md border border-border bg-surface px-4 py-3 text-sm font-medium text-ink-muted shadow-panel" role="status">
        正在加载 Merry…
      </p>
    </div>
  );
}
